<template>
  <div class="create-report">
    <cc-form
      v-model="formData"
      labelWidth="150px"
      ref="form"
      :config="formConfig"
      :rules="rules"
    ></cc-form>

    <div class="action" style="margin-left: 120px; margin-top: 20px">
      <el-button size="mini" @click="$emit('cancel')">
        {{ this.$t("statistics.cancel") }}
      </el-button>
      <el-button size="mini" type="primary" @click="onSubmit">
        {{ this.$t("statistics.submit") }}
      </el-button>
    </div>
  </div>
</template>

<script>
// 财务费用提报

const defaultFormData = {
  id: "",
  jobId: "",
  feeMonth: "",
  feeType: "",
  laborCost: "",
  travelCost: "",
  partsCost: "",
  otherCost: "",
  remark: "",
};

const makeReadComponent = (returnField) => {
  return {
    props: {
      value: [String, Number],
      formData: { type: Object },
    },
    methods: {
      deepValue(field) {
        const d = field.split(".");
        let value = this.formData;
        for (const item of d) {
          const val = value[item];
          if (!val) return null;
          else {
            value = val;
          }
        }
        return value;
      },
    },
    render(h) {
      return h("span", null, this.deepValue(returnField));
    },
  };
};

export default {
  name: "EditReport",
  props: {
    value: {
      type: Object,
      default: () => ({ ...defaultFormData }),
    },
  },
  watch: {
    value(val) {
      this.formData = this.convertValue({ ...defaultFormData, ...val });
    },
  },
  data() {
    const validatorNumber = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (isNaN(Number(value))) {
        callback(new Error(this.$t("statistics.tips.validNumberError")));
      } else {
        callback();
      }
    };
    const formData = this.convertValue({ ...defaultFormData, ...this.value });
    return {
      formData,
      formConfig: {
        props: [
          {
            type: "component",
            name: "jobId",
            label: "Job ID",
            componentName: makeReadComponent("product.jobId"),
          },
          {
            // type: "date",
            type: "component",
            name: "feeMonth",
            label: this.$t("statistics.feeMonth"),
            componentName: makeReadComponent("feeMonth"),
          },
          {
            type: "select",
            name: "feeType",
            label: this.$t("statistics.feeType"),
            options: [
              { label: this.$t("statistics.constants.feeType[0]"), value: 0 },
              { label: this.$t("statistics.constants.feeType[1]"), value: 1 },
              { label: this.$t("statistics.constants.feeType[2]"), value: 2 },
            ],
          },
          {
            type: "input",
            name: "laborCost",
            label: this.$t("statistics.laborCost"),
          },
          {
            type: "input",
            name: "travelCost",
            label: this.$t("statistics.travelCost"),
          },
          {
            type: "input",
            name: "partsCost",
            label: this.$t("statistics.partsCost"),
          },
          {
            type: "input",
            name: "otherCost",
            label: this.$t("statistics.otherCost"),
          },
          {
            type: "textarea",
            name: "remark",
            label: this.$t("statistics.remark"),
          },
        ],
      },
      rules: {
        feeType: [
          {
            required: true,
            message: this.$t("statistics.tips.validFeeType"),
            trigger: "blur",
          },
        ],
        laborCost: [{ validator: validatorNumber, trigger: "blur" }],
        travelCost: [{ validator: validatorNumber, trigger: "blur" }],
        partsCost: [{ validator: validatorNumber, trigger: "blur" }],
        otherCost: [{ validator: validatorNumber, trigger: "blur" }],
      },
    };
  },
  methods: {
    /**
     * 表單cost 值處理，除以100
     */
    convertValue(form) {
      const costs = ["laborCost", "travelCost", "partsCost", "otherCost", "salesFee"];
      const data = Object.keys(form).reduce(
        (pre, cur) => {
          if (costs.includes(cur)) {
            pre[cur] /= 100;
          }
          return pre;
        },
        { ...form }
      );
      return data;
    },
    onSubmit() {
      const elFormRef = this.$refs["form"].$refs.myform;
      elFormRef.validate((valid) => {
        if (!valid) return false;
        // 筛选，只传修改内容
        let formData = Object.keys(defaultFormData).reduce((pre,cur) => {
          pre[cur] = this.formData[cur];
          return pre;
        }, {...defaultFormData})

        if (formData.laborCost) {
          formData.laborCost = formData.laborCost * 100;
        }
        if (formData.travelCost) {
          formData.travelCost = formData.travelCost * 100;
        }
        if (formData.partsCost) {
          formData.partsCost = formData.partsCost * 100;
        }
        if (formData.otherCost) {
          formData.otherCost = formData.otherCost * 100;
        }
        if (formData.salesFee) {
          formData.salesFee = formData.salesFee * 100;
        }
        this.createReport(formData)
          .then(() => {
            this.$emit("done");
          })
          .catch((err) => {
            this.$message.error(err.response.data.message);
          });
      });
    },
    async createReport(payload) {
      return await this.ccRequest.do(
        "admin/fsb/financial/save",
        payload,
        "POSTJSON"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.create-report {
}
</style>
